import IncomeTableEastern from './IncomeTableEastern';

export default IncomeTableEastern;
